import React, { useEffect } from 'react'
import { Alert } from 'components'
import { Form } from 'components/Form'
import { alerts as alertKeys } from 'keys'
import { useAlert } from 'components/Alerts/hooks'
import { initialize, reset } from 'redux-form'
import { useDispatch } from 'react-redux'
import { validate } from 'pages/Coupon'
import { couponHooks } from '.'

const CreateCouponPopup = () => {
    const dispatch = useDispatch()

    const { setAlerts } = useAlert()

    const couponFields = couponHooks.useCouponFields()
    const submitBtns = couponHooks.useSubmitBtns()
    const { formname } = couponHooks.constants

    useEffect(() => {
        return (() => {
            dispatch(reset(formname))
            dispatch(initialize(formname, {}));
        })
    }, [])

    return (
        <Alert
            systemUI
            title={`יצירת קופון חדש`}
            footerActions={submitBtns}
            handleAlert={() => setAlerts(alertKeys.createCoupon, false)}
        >
            <div>
                <Form
                    form={formname}
                    validations={validate}
                    fields={couponFields}
                    submit={() => { }}
                />
            </div>
        </Alert>
    )
}

export default CreateCouponPopup